import React from "react"
import { graphql } from "gatsby"
import { Typography } from "antd"
import Layout from "../../../components/Layout"
import "../../../styles/odooServices.scss"
import "../../../styles/services.scss"
import "../../../styles/caseStudy.scss"
import News from "../../../components/News"
import ProductTopSection from "../../../components/ProductTopSelection"
import ServiceCard from "../../../components/ServiceCard"
import Wethoughtyoumighthavequestions from "../../../components/Wethoughtyoumighthavequestions"
import CaseStudeiesSimplified from "../../../components/CaseStudeiesSimplified"
import sc_performance from "../../../images/servicecard/performance.png"
import sc_deployment from "../../../images/servicecard/deployment.png"
import sc_integration from "../../../images/servicecard/integration.png"
import sc_cloud from "../../../images/servicecard/cloud.png"
import sc_legacy from "../../../images/servicecard/legacy.png"
import sc_testing from "../../../images/servicecard/Automated testing.png"

import headerImage from "../../../images/ViztosPos/top_header_art_double_tab.png"
import img1 from "../../../images/ViztosPos/1.png"
import img2 from "../../../images/ViztosPos/2.png"
import img3 from "../../../images/ViztosPos/3.png"
import img4 from "../../../images/ViztosPos/4.png"
import img5 from "../../../images/ViztosPos/5.png"
import img6 from "../../../images/ViztosPos/1.png"
import img7 from "../../../images/ViztosPos/7.png"
import img8 from "../../../images/ViztosPos/8.png"
import img9 from "../../../images/ViztosPos/9.png"
import img10 from "../../../images/ViztosPos/10.png"

import ImageWithTextSection from "../../../components/ImageWithTextSection"
import IconsAdded from "../../../components/IconsAdded"

const { Title } = Typography

const Viztos = ({ data }) => {
  return (
    <div className="CaseStudeies">
      <Layout pageTitle={"Visiomate - Viztos a Cafe / Oil Lubricant Management"}
      descrip = {"Our cafe/oil lubricant management software offers powerful tools for inventory control, sales tracking, customer relationship management, and more. Boost your business today!"}>
        <ProductTopSection
          headerData={{
            title:
              "Viztos: a POS solution perfect for Cafe & Lubricant Stations.  ",
            peragraph:
              "A customized Odoo-based POS solution designed to overcome common limitations faced by businesses. Perfect for drive-through cafes and lubricant stations, Viztos features a user-friendly Front End and an efficient Odoo backend, mitigating issues like multiple sessions and advanced UI design.",
            image: headerImage,
          }}
          data={data}
        />
        <div className="services-page-container position-relative">
          <div className="services-description-section">
            <div className="service-heading-and-detail">
              <Title>The Smarter POS Built for Cafes &amp; Lubricant Stations</Title>
            </div>
            <div className="service-cards-wrapper">
              <ServiceCard
                img_src={sc_performance}
                img_alt="Drive-through Cafes and Lubricant Stations"
                card_heading="Ideal for Drive-through Cafes and Lubricant Stations"
                card_para="Viztos interface is finely tuned for drive-through cafes and lubricant stations, ensuring swift and effortless order creation for enhanced efficiency."
              />
              <ServiceCard
                img_src={sc_deployment}
                img_alt="Job Card for Lubricant station"
                card_heading="Job Card for Lubricant station"
                card_para="Viztos offers comprehensive solutions for lubricant stations, including features like job cards and vehicle mileage history tracking, seamlessly completing the order-taking process."
              />
              <ServiceCard
                img_src={sc_integration}
                img_alt="Better Collaboration"
                card_heading="Better Collaboration"
                card_para="Viztos provides multiple interfaces for effective information dissemination to all stakeholders, ensuring seamless communication and operation."
              />
              <ServiceCard
                img_src={sc_cloud}
                img_alt="Daily Sales & Closing Reports"
                card_heading="Daily Sales & Closing Reports"
                card_para="Viztos offers a variety of reports tailored to assist both shop staff and the back-office team, including Daily Sales, Hourly Sales, Petty Cash, and Closing Reports."
              />
              <ServiceCard
                img_src={sc_legacy}
                img_alt="Holistic Data Integration"
                card_heading="Holistic Data Integration"
                card_para="Integration of data across departments provides a comprehensive view of the organization, allowing for better-informed decision-making."
              />
              <ServiceCard
                img_src={sc_testing}
                img_alt="Time and Cost Savings"
                card_heading="Time and Cost Savings"
                card_para="Automation of tasks, such as inventory management and sales reporting, saves time and reduces the need for manual labor."
              />
            </div>
          </div>
        </div>
        <ImageWithTextSection
          title="Explore Viztos in Action"
          caseStudyData={{
            data: [
              {
                heading: "Customizable & Friendly POS Interface",
                description:
                  "The Customizable & Friendly interface streamlines transactions, allowing users to easily navigate through different options, select items, and process payments with a simple tap or swipe.",
                image: img1,
              },
              {
                heading: "TOPUP & Petty Cash",
                description:
                  "Shopkeepers have the flexibility to view and manage customer top-ups and daily petty cash directly within the POS interface.",
                image: img2,
              },
              {
                heading: "Orders History",
                description:
                  "A detailed order history allows shop keeper to view past transactions, monitor the status, and print duplicate invoices of their orders.",
                image: img3,
              },
              {
                heading: "Multiple Payment Methods",
                description:
                  "Viztos offers effortless payment processing with multiple methods and standout tap-to-pay integration, ensuring seamless transactions for customers.",
                image: img4,
              },
              {
                heading: "Dynamic Kitchen Display Screen",
                description:
                  "This technology leverages dynamic, real-time information to enhance communication and coordination between the kitchen staff, improving overall kitchen operations.",
                image: img5,
              },
              {
                heading: "Job Card",
                description:
                  "A lubricant job card is a document used in automotive maintenance to record details of lubrication services performed on a vehicle.",
                image: img6,
              },
              {
                heading: "Hourly Sales Report",
                description:
                  "Viztos hourly sales report provides detailed information about the sales transactions and revenue generated every hour of the session",
                image: img7,
              },
              {
                heading: "Sales Closing Report",
                description:
                  "Viztos sales closing report is a summary document that provides information about the sales transactions and revenue generated within a single business day.",
                image: img8,
              },
              {
                heading: "Price & Quantity Update",
                description:
                  "Viztos provides price & quantity update feature on POS level, if shop manager have the access to this feature then price & quantity can be managed with out going to the back office.",
                image: img9,
              },
              {
                heading: "Remote Dispaly for Drive-through",
                description:
                  "Viztos modernizes drive-through ordering with integrated video and audio conferencing, enhancing customer experience.",
                image: img10,
              },
            ],
          }}
          dataFormImages={data}
        />
        {/* <CaseStudeiesSimplified
          TextData={{
            title: "Simplified Steps to get you Started ",
            Data: [
              {
                peragraph: "Define Requirements",
                list: [
                  "Clearly outline your business objectives and identify the specific challenges or needs that the software solution should address.",
                  "List down the essential features and functionalities required.",
                ],
              },
              {
                peragraph: "Demo and Evaluation",
                list: [
                  "Schedule product demonstrations. ",
                  "Evaluate the software's usability, features, and performance. ",
                  "Engage key stakeholders in the evaluation process.",
                ],
              },
              {
                peragraph: "Scalability and Integration",
                list: [
                  "Identify the potential integrations required by the customer.",
                  "Plan the implementation of identified integrations.",
                ],
              },
              {
                peragraph: "UAT & User Feedback",
                list: [
                  "UAT period allows customer to assess the system performance and suitability for the specific business needs.",
                  "Customer’s insights can provide valuable perspectives on usability, functionality mismatch.",
                ],
              },
              {
                peragraph: "User Training",
                list: [
                  " User training is a critical component of successfully implementing the software solution.",
                  "Proper training ensures that users can effectively and efficiently utilize the software, maximizing its benefits.",
                ],
              },
              {
                peragraph: "Post-Implementation Support",
                list: [
                  "Provide ongoing support for users.",
                  "Address any post-implementation issues.",
                  "Evaluate and implement system enhancements based on feedback.",
                ],
              },
            ],
          }}
        /> */}
        <Wethoughtyoumighthavequestions
          data={[
            {
              question: "What is Viztos and who is it built for?",
              answer: "Viztos is a specialized POS solution built on Odoo, designed specifically for drive-through cafes and lubricant stations. It combines a fast, touch-friendly front end with a powerful Odoo backend to handle everything from order-taking to job cards and daily reporting.",
            },
            {
              question: "How does Viztos improve speed at the point of sale?",
              answer: "Viztos features a streamlined, touch-optimized interface that lets staff create orders, apply discounts, and process payments in seconds. With tap-to-pay integration and a dynamic kitchen display screen, orders flow from counter to kitchen without any manual handoffs.",
            },
            {
              question: "Does Viztos support lubricant station–specific workflows?",
              answer: "Yes. Viztos includes dedicated job card management for lubricant stations, capturing vehicle details, service history, and mileage records directly within the POS session — eliminating the need for separate paperwork.",
            },
            {
              question: "What payment methods does Viztos support?",
              answer: "Viztos supports cash, credit/debit cards, tap-to-pay (NFC), and customer top-up wallets. Multiple payment methods can be combined in a single transaction, giving customers full flexibility at checkout.",
            },
            {
              question: "What reporting does Viztos provide for business owners?",
              answer: "Viztos generates Daily Sales Reports, Hourly Sales Breakdowns, Petty Cash summaries, and full Closing Reports — giving shop owners and back-office teams the visibility they need without any manual data entry.",
            },
            {
              question: "Can Viztos connect to our existing ERP or accounting system?",
              answer: "Viztos is built on Odoo, so it connects natively to Odoo's full ERP suite — including CRM, Inventory, Purchasing, and Accounting — giving your back office real-time data from every transaction.",
            },
          ]}
          title="We thought you might have questions"
        />
        <News isAbout={true} career={true} />
      </Layout>
    </div>
  )
}

export default Viztos
export const query = graphql`
  query VitozImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    HeaderImg: file(
      relativePath: { eq: "ViztosPos/top_header_art_double_tab.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(
      relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImages: file(relativePath: { eq: "prodbg-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img1: file(relativePath: { eq: "ViztosPos/1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img2: file(relativePath: { eq: "ViztosPos/2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img3: file(relativePath: { eq: "ViztosPos/3.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img4: file(relativePath: { eq: "ViztosPos/4.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img5: file(relativePath: { eq: "ViztosPos/5.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img6: file(relativePath: { eq: "ViztosPos/1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img7: file(relativePath: { eq: "ViztosPos/7.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img8: file(relativePath: { eq: "ViztosPos/8.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img9: file(relativePath: { eq: "ViztosPos/9.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img10: file(relativePath: { eq: "ViztosPos/10.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
